import { Button, Col, Row, Typography } from 'antd'
import React from 'react'
// import { nbsp } from '../../../Constants'
import { handleMyTax } from '../../../helper'
import './SelfEmployedStatus.css'
import PersistentCooldownButton from './PersistentCooldownButton'
import { storageKeys } from '../../../Constants'

const { Title } = Typography

export default function ActiveSelfEmployedStatus ({ onClick, loading }) {
  const handleClick = () => {
    onClick?.()
  }

  return (
    <Row justify='space-between' className='selfEmployedStatus '>
      <Col span={24} className='info-block'>
        <Row>
          <Col span={24}>
            <Title level={3}>Остался последний шаг</Title>
            <p>Получите статус самозанятого</p>
            <p>С ним вы сможете выполнять заказы и оказывать услуги</p>
            <ul>
              <li>Перейдите в «Мой налог» — на сайт или в приложение</li>
              <li>Зарегистрируйтесь, используя любой удобный метод. Важно оформлять самозанятость на этот же номер телефона</li>
              <li>Дождитесь сообщения о регистрации. Обычно это занимает не более 5 минут</li>
              <li>Вернитесь на этот экран и нажмите «Готово»</li>
            </ul>
            <p>Если у вас уже есть статус самозанятого или если возникли сложности, звоните: 8 800 250 54 50</p>
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <img src='/img/pencil.png' className='pencil' />
          </Col>
        </Row>
      </Col>

      <Col span={24} className='btn-block'>
        <Button
          className='btn-my-tax'
          size='large'
          block
          onClick={handleMyTax}
        >
          <img src='/img/fns.png' className='mr-3' />Перейти в «Мой налог»
        </Button>
        <PersistentCooldownButton
          text='Готово'
          storageKey={storageKeys.cooldownActiveSelfEmployedStatus}
          size='large'
          type='primary'
          className='margin-top-20 margin-bottom-20 ant-btn-background-ghost'
          loading={loading}
          onClick={handleClick}
        />
      </Col>
    </Row>
  )
}
